export default __webpack_public_path__ + "static/image_whatsapp_button-f54d03a7a3318aeecc29f9cca355d818.png";